import { COLUMN_ACCESS, COLUMN_CATEGORY, COLUMN_COMPANY, COLUMN_DEPARTMENT, COLUMN_DISPLAY_NAME, COLUMN_ENABLED, COLUMN_FIRST_NAME, COLUMN_GENDER, COLUMN_LAST_NAME, COLUMN_SECOND_NAME, COLUMN_SITE, COLUMN_SUFFIX, COLUMN_TITLE, COLUMN_UNIQUE_IDENTIFIER } from "../../constants/column-types";
import { FILTER_COMPANIES, FILTER_DEPARTMENTS, FILTER_PROFILE, FILTER_SITES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const AbsenteeismReportColumn : TableColumn[] = [
    {
        heading: "Unique Identifier",
        accessor: "uniqueIdentifier",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "uniqueIdentifier",
        columnId: COLUMN_UNIQUE_IDENTIFIER
    },
    {
        heading: "Title",
        accessor: "title",
        isNumeric: false,
        id: 2,
        active: false,
        translationKey: "title",
        columnId: COLUMN_TITLE
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        isNumeric: false,
        id: 3,
        active: true,
        translationKey: "displayName",
        columnId: COLUMN_DISPLAY_NAME
    },
    {
        heading: "First Name",
        accessor: "firstName",
        isNumeric: false,
        id: 4,
        active: true,
        translationKey: "firstName",
        columnId: COLUMN_FIRST_NAME
    },
    {
        heading: "Second Name",
        accessor: "middleName",
        isNumeric: false,
        id: 5,
        active: false,
        translationKey: "secondName",
        columnId: COLUMN_SECOND_NAME
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        isNumeric: false,
        id: 6,
        active: true,
        translationKey: "lastName",
        columnId: COLUMN_LAST_NAME
    },
    {
        heading: "Suffix",
        accessor: "suffix",
        isNumeric: false,
        id: 7,
        active: false,
        translationKey: "suffix",
        columnId: COLUMN_SUFFIX
    },
    {
        heading: "Department",
        accessor: "department",
        isNumeric: false,
        id: 8,
        active: true,
        searchOnName: "departmentId",
        lookupName: "department",
        translationKey: "department",
        columnId: COLUMN_DEPARTMENT,
        filterId: FILTER_DEPARTMENTS,
        settingDataName: 'department'
    },
    {
        heading: "Company",
        accessor: "company",
        isNumeric: false,
        id: 9,
        searchOnName: "companyId",
        lookupName: "company",
        active: false,
        translationKey: "company",
        columnId: COLUMN_COMPANY,
        filterId: FILTER_COMPANIES,
        settingDataName: 'company'
    },
    {
        heading: "Category",
        accessor: "category",
        isNumeric: false,
        id: 10,
        searchOnName: "profileId",
        lookupName: "category",
        active: false,
        translationKey: "category",
        columnId: COLUMN_CATEGORY,
        filterId: FILTER_PROFILE,
        settingDataName: 'profile'
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 11,
        searchOnName: "site.id",
        lookupName: "site",
        active: false,
        translationKey: "site",
        columnId: COLUMN_SITE,
        filterId: FILTER_SITES,
        settingDataName: 'site'
    },
    {
        heading: "Enabled Credentials",
        accessor: "current",
        isNumeric: false,
        id: 12,
        active: false,
        translationKey: "enableCredentials",
        columnId: COLUMN_ENABLED
    },
    {
        heading: "Access Type",
        accessor: "mtName",
        isNumeric: false,
        id: 13,
        active: false,
        translationKey: "accessType",
        columnId: COLUMN_ACCESS
    },
    {
        heading: "Gender",
        accessor: "gender",
        isNumeric: false,
        id: 14,
        active: false,
        translationKey: "gender",
        columnId: COLUMN_GENDER
    },
]

export default AbsenteeismReportColumn;
